
window.onload = function() {

    jQuery('#easterletter_custom_popup h1').html("EASTER HUNT LETTER");
  
    jQuery('.product-info__price').clone().insertAfter(jQuery('#easterletter_custom_popup h1'));

    jQuery('.template-product .product-detail__images-container').css('opacity',1);

    var state_map = {
        "Australian Capital Territory":"ACT",
        "New South Wales":"NSW",
        "Northern Territory":"NT",
        "Queensland":"QLD",
        "South Australia":"SA",
        "Tasmania":"TAS",
        "Victoria":"VIC",
        "Western Australia":"WA"
    };

    jQuery('button.open_letter_popup').click(function(){

      if(jQuery("#easter-letter-questions #childname").val() && jQuery("#easter-letter-questions #question1").val() && jQuery("#easter-letter-questions #delivery-firstname").val() && 
          jQuery("#easter-letter-questions #delivery-lastname").val() && jQuery("#easter-letter-questions #address").val() && jQuery("#easter-letter-questions #suburb").val() && jQuery("#easter-letter-questions #postcode").val()){

      }else{
          alert("Please enter all the fields.");
          return;
      }

      // Regular expression to match emoji
      const regexExp = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/gi;
      
      if(regexExp.test(jQuery("#easter-letter-questions #childname").val()) || regexExp.test(jQuery("#easter-letter-questions #question1").val()) || regexExp.test(jQuery("#easter-letter-questions #delivery-firstname").val()) || regexExp.test(jQuery("#easter-letter-questions #delivery-lastname").val()) ){
        alert("Sorry, Emojis are not allowed.");
        return;
      }
  
      // Check if contains |
      if(jQuery("#easter-letter-questions #childname").val().indexOf("|") != -1 || jQuery("#easter-letter-questions #delivery-firstname").val().indexOf("|") != -1 
         || jQuery("#easter-letter-questions #delivery-lastname").val().indexOf("|") != -1){
        alert("Sorry, special characters are not allowed.");
        return;
      }

      
      let letter_content = jQuery("#easter-letter-questions #delivery-firstname").val() + " " + jQuery("#easter-letter-questions #delivery-lastname").val() + "<br/>";
      letter_content += jQuery("#easter-letter-questions #address").val() + "<br/>" + jQuery("#easter-letter-questions #suburb").val() + " " + jQuery("#easter-letter-questions #state").val() + " " + jQuery("#easter-letter-questions #postcode").val() + "<br/>" + jQuery("#easter-letter-questions #country").val() + "<br/><br/><br/>";

      letter_content += "Dear " + jQuery("#easter-letter-questions #childname").val() + ",<br/><br/>";
      letter_content += "Greetings from my burrow! It’s me, the Easter Bunny!<br/><br/>";
      
      letter_content += "I am so EGG-cited that Easter is finally here. <br/>";
      letter_content += "While Santa rests, the little chicks and I have been busy decorating eggs preparing for an Easter Hunt just for you! ";
      letter_content += "I have been to " + jQuery("#easter-letter-questions #question1").val() + ", and here I have hidden some treats. ";
      letter_content += "An adventure awaits but you will have to be wise and follow all the clues to find your special prize. ";
      letter_content += "Hop to it little bunny, now the time has come for you to jump into your Easter Hunt.<br/><br/>";
      
      letter_content += "The fun has begun, hippity-hop to clue number one. <br/>";
      letter_content += jQuery("#easter-letter-questions #question2").val() + "<br/><br/>";

      letter_content += "Now jump roll and skip into clue number two. <br/>";
      letter_content += jQuery("#easter-letter-questions #question3").val() + "<br/><br/>";

      letter_content += "Quietly creep to discover clue number three. <br/>";
      letter_content += jQuery("#easter-letter-questions #question4").val() + "<br/><br/>";

      letter_content += "Wiggle that tail, you’re on the right trail to clue number four. <br/>";
      letter_content += jQuery("#easter-letter-questions #question5").val() + "<br/><br/>";

      letter_content += "Hop to it, this is my final clue, but your Easter adventure is not yet through. <br/>";
      letter_content += jQuery("#easter-letter-questions #question6").val() + "<br/><br/>";
      
      letter_content += "This rhyming has come to an end but keep looking high and low, as my eggs land in funny places when I throw. <br/><br/>";

      letter_content += "I hope you have a wonderful Easter. Enjoy this special time with all your family and friends. ";

      letter_content += "After all, this is what Easter is about. Now do remember to share your goodies and try not to eat them all in one go. <br/><br/>";
      
      letter_content += "Happy Easter!<br/><br/>";

      jQuery("#easterletter_custom_popup .content-wrapper").html(letter_content);
      
      jQuery("#easterletter_custom_popup, #custom_popup-bg").show();
    });

    jQuery('body').on('click','#product-editcart-button',function(){
      jQuery("#easterletter_custom_popup, #custom_popup-bg").hide();
    });

    jQuery('body').on('click','#product-addtocart-button',function(){

        let variant_id = jQuery("#prod-info").attr("p_varient_id");
        let properties = {};
    
        jQuery("#easter-letter-questions input, #easter-letter-questions select").each(function(){

          let input_name = $(this).attr("name");

          input_name = input_name.replace("properties[","");
          input_name = input_name.replace("]","");
    
          properties[input_name] = $(this).val();
    
          //console.log(input_name + $(this).val());
        });
    
        //console.log("Variant_id " + variant_id);
        console.log(properties);
    
        // add to cart - START
        let formData = {
          'items': [{
           'id': variant_id,
           'quantity': 1,
           properties : properties
           }]
         };
         fetch('/cart/add.js', {
           method: 'POST',
           headers: {
             'Content-Type': 'application/json'
           },
           body: JSON.stringify(formData)
         })
         .then(response => {
            //refresh cart icon & drawer - START
            const cartComponent = jQuery('.cart-link');
            if (cartComponent.length > 0) {
              cartComponent.load(window.location.href + ' .cart-link');
            };

            function handleResponse() {
              let result = JSON.parse(this.responseText);
              jQuery('.section-cart-drawer').html(result["sections--16283649441846__cart-drawer"]);
            }
            const request = new XMLHttpRequest();
            
            request.addEventListener('load', handleResponse);
            request.open('GET', '/?sections=sections--16283649441846__cart-drawer', true);
            request.send();
            //refresh cart icon & drawer - END
           
           return response.json();
         })
         .catch((error) => {
           console.error('Error:', error);
         });
    
         // add to cart - END

      
      jQuery("#easterletter_custom_popup, #custom_popup-bg").hide();
      //jQuery("#upsell-popup-bg").show();
      jQuery("#product-recommendations-popup").css('display','flex');
      window.scrollTo(0,0);
    });

    jQuery('body').on('click','.upsell-continueshopping', function(e){
      e.preventDefault();
      //jQuery("#upsell-popup-bg").hide();
      jQuery("#product-recommendations-popup").hide();
    });

}